/**
 * isDev
 *
 * Utility to check if the application is running in development mode.
 * Use this to conditionally execute code only in development environments.
 */

export const isDev = process.env.NODE_ENV === 'development'
